import { render, staticRenderFns } from "./assessRiskRegister.vue?vue&type=template&id=2a1adcee"
import script from "./assessRiskRegister.vue?vue&type=script&lang=js"
export * from "./assessRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1adcee')) {
      api.createRecord('2a1adcee', component.options)
    } else {
      api.reload('2a1adcee', component.options)
    }
    module.hot.accept("./assessRiskRegister.vue?vue&type=template&id=2a1adcee", function () {
      api.rerender('2a1adcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/assessRiskRegister.vue"
export default component.exports